import Options from "../../data/options";

class KlausurSchema {
  constructor(companies, currentUser) {
    this.companies = companies;
    this.currentUser = currentUser;
    this.fields = {
      companyId: {
        name: "companyId",
        type: "number",
        fieldType: "select",
        label: "Schule",
        col: 5,
        required: true,
        sort: 2,
        validation: {
          minLength: 1
        },
        options: [
          {key: 0, value: ""},
          ...companies.map(c => {
            return {key: c.id, value: `${c.name} (${c.land})`};
          })
        ],
        initialValue: currentUser.companyId || 0
      },
      fach: {
        name: "fach",
        type: "string",
        fieldType: "select",
        label: "Fach",
        col: 4,
        required: true,
        sort: 3,
        validation: {
          maxLength: 1,
          minLength: 1
        },
        options: Options.fach,
        initialValue: "e"
      },
      pruefungsart: {
        name: "pruefungsart",
        type: "string",
        fieldType: "select",
        label: "Prüfungsart",
        col: 3,
        required: true,
        sort: 4,
        validation: {
          maxLength: 2,
          minLength: 1
        },
        options: Options.pruefungsart,
        initialValue: "k"
      },
      gutachter: {
        name: "gutachter",
        type: "string",
        fieldType: "select",
        label: "Gutachter",
        col: 2,
        sort: 4.5,
        initialValue: "",
        options: Options.gutachter
      },
      kursart: {
        name: "kursart",
        type: "string",
        fieldType: "select",
        label: "Kursart",
        col: 2,
        required: true,
        sort: 5,
        validation: {
          maxLength: 1,
          minLength: 1
        },
        initialValue: "g",
        options: Options.kursart
      },
      date: {
        name: "date",
        type: "string",
        fieldType: "date",
        required: true,
        label: "Datum",
        col: 2,
        sort: 4.5,
        validation: {
          minLength: 1
        }
      },

      halbjahr: {
        name: "halbjahr",
        type: "string",
        fieldType: "select",
        label: "Kurs- / Schulhalbjahr",
        col: 3,
        required: true,
        sort: 6,
        validation: {
          maxLength: 20,
          minLength: 1
        },
        options: Options.halbjahr,
        initialValue: "sh1"
      },
      klausurnummer: {
        name: "klausurnummer",
        type: "string",
        fieldType: "select",
        label: "Klausurnummer",
        col: 3,
        sort: 7,
        options: Options.klausurnummer,
        initialValue: ""
      },
      aufgabenart: {
        name: "aufgabenart",
        type: "string",
        fieldType: "select",
        label: "Aufgabenart",
        col: 3,
        sort: 8,
        options: Options.aufgabenart,
        initialValue: "t"
      },

      prozentAfb1: {
        name: "prozentAfb1",
        type: "number",
        initialValue: 30,
        fieldType: "integer",
        label: "Anteil AFB I in Prozent",
        col: 3,
        sort: 9,
        step: 5,
        breakBefore: true
      },
      prozentAfb2: {
        name: "prozentAfb2",
        type: "number",
        initialValue: 40,
        fieldType: "integer",
        label: "Anteil AFB II in Prozent",
        col: 3,
        sort: 10,
        step: 5
      },
      prozentAfb3: {
        name: "prozentAfb3",
        type: "number",
        initialValue: 30,
        fieldType: "integer",
        label: "Anteil AFB III in Prozent",
        col: 3,
        sort: 11,
        step: 5,
        disabled: true
      },
      sprachverwendung: {
        name: "sprachverwendung",
        type: "number",
        initialValue: 15,
        fieldType: "integer",
        label: "Sprachverwendung in Prozent",
        col: 3,
        sort: 12
      }
    };
    this.conditions = {
      keys: [
        "companyId",
        "fach",
        "pruefungsart",
        "kursart",
        "date",
        "halbjahr",
        "klausurnummer",
        "aufgabenart",
        "prozentAfb1",
        "prozentAfb2",
        "prozentAfb3",
        "sprachverwendung"
      ],
      laender: {
        Berlin: {deleteFields: []},
        Brandenburg: {deleteFields: ["sprachverwendung", "gutachter"]}
      },
      pruefungsart: {
        a: {deleteFields: ["halbjahr", "klausurnummer"]},
        an: {deleteFields: ["halbjahr", "klausurnummer"]},
        k: {deleteFields: ["gutachter"]}
      },
      kursart: {
        g: {deleteFields: ["klausurnummer"]}
      }
    };
  }
  getEmpty(value) {
    return typeof value === "number" ? 0 : "";
  }
  getFields(variables) {
    if (!variables) return this.fields;
    const keys = Object.keys(this.fields);
    const company = this.companies.find(c => c.id === parseInt(variables.companyId));
    const land = company?.land || "";
    const {pruefungsart, kursart} = variables;
    const deleteFieldsLand = this.conditions.laender[land]?.deleteFields || [];
    const deleteFieldsPruefungsart = this.conditions.pruefungsart[pruefungsart]?.deleteFields || [];
    const deleteFieldsKursart = this.conditions.kursart[kursart]?.deleteFields || [];
    const deleteFieldsAll = [...deleteFieldsLand, ...deleteFieldsPruefungsart, ...deleteFieldsKursart];
    const activeKeys = keys.filter(k => !deleteFieldsAll.includes(k));
    const fields = {};
    activeKeys.forEach(k => (fields[k] = this.fields[k]));
    // console.log({
    //   deleteFieldsPruefungsart,
    //   deleteFieldsLand,
    //   deleteFieldsKursart,
    //   deleteFieldsAll,
    //   land,
    //   company,
    //   keys,
    //   kursart,
    //   keys,
    //   activeKeys,
    //   fields,
    // });
    return fields;
  }
}

export default KlausurSchema;
